import Paginacao from '@/core/store/default/paginacaoListagem'

export default {
	filtro: {
		idAditivoApostila: null,
	},
	paginacao: Paginacao([]),
	idAditivoApostila: null,
	tipoOperacao: 'ACRESCIMO',
	quantidade: null,
	isSelecionouTodosItensAditivoApostila: false,
	itensAditivoApostilaSelecionados: [],
}
